/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrRowSeparator } from './igr-row-separator';
import { RowSeparator } from './RowSeparator';
import { TypeRegistrar } from "igniteui-react-core";
var IgrRowSeparatorModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrRowSeparatorModule() {
    }
    IgrRowSeparatorModule.register = function () {
        TypeRegistrar.registerCons("IgrRowSeparator", IgrRowSeparator);
        TypeRegistrar.register("RowSeparator", RowSeparator.$type);
    };
    return IgrRowSeparatorModule;
}());
export { IgrRowSeparatorModule };
//# sourceMappingURL=igr-row-separator-module.js.map
